import { useQuery } from "@tanstack/react-query"
import { getAsientoContableModelo180 } from "api/AsientoContable.service"
import { MODELO_IMPUESTO } from "api/Types/ModeloImpuesto"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "../../../../../../routes/RoutePaths"
import { HandleTabs } from "../../DetalleImpuestos"
import ModeloAnual from "../ModeloAnual"
import { RedirectParams } from "../constants"

export const Modelo180 = ({
  props: { year, handleYearSelection, yearsOptionList },
}: {
  props: HandleTabs
}) => {
  const { t } = useTranslation()
  const history = useHistory()
  const navigate = ({ route, periodo, modelo, year }: RedirectParams) => {
    history.push(route, {
      periodo,
      modelo,
      year,
    })
  }

  const fetchModelo180 = async () => {
    const data = await getAsientoContableModelo180({
      Anyo: year.selectedYear,
    })
    return data
  }

  const { data, isLoading } = useQuery({
    queryKey: ["modelo180", year.selectedYear],
    queryFn: fetchModelo180,
    select: (data) => {
      if (!data) return
      return [
        {
          text: t("taxSummary.table180TextOne"),
          value: data.totalPerceptores,
          currencyFormat: false,
        },
        {
          text: t("taxSummary.table180TextTwo"),
          value: data.totalPercepcion,
          currencyFormat: true,
        },
        {
          text: t("taxSummary.table180TextThree"),
          value: data.totalRetencion,
          currencyFormat: true,
        },
      ]
    },
  })

  return (
    <ModeloAnual
      t={t}
      year={year}
      handleYearSelection={handleYearSelection}
      yearsOptionList={yearsOptionList}
      navigateDeclaracion={() =>
        navigate({
          route: `${ROUTES.DECLARACION_MODELO_180}`,
          year: year.selectedYear,
        })
      }
      navigate={() =>
        navigate({
          route: `${ROUTES.RESUMEN_IMPUESTOS_DETAIL_180}`,
          modelo: MODELO_IMPUESTO.MODELO_180,
          year: year.selectedYear,
        })
      }
      isLoading={isLoading}
      data={data}
    />
  )
}
